import { accommodationsCurrencySymbolByCountry, accommodationsCurrencySymbolByCountryForPosBg, currencySymbolByPointOfSale, currencySymbolByPointOfSaleForPosBg } from "./pointOfSaleToCurrency.js";
export const getCurrencySymbolByPointOfSale = (pointOfSale, forceBgToEur) => {
    if (forceBgToEur) {
        return currencySymbolByPointOfSaleForPosBg[pointOfSale];
    }
    return currencySymbolByPointOfSale[pointOfSale];
};
export const getAccommodationsCurrencySymbolByCountry = (countryCode, forceBgToEur) => {
    if (forceBgToEur) {
        return accommodationsCurrencySymbolByCountryForPosBg[countryCode];
    }
    return accommodationsCurrencySymbolByCountry[countryCode];
};
export const SUPPORTED_CURRENCIES = [
    "EUR",
    "USD",
    "SEK",
    "NOK",
    "DKK",
    "GBP",
    "AUD",
    "UAH",
    "PLN",
    "CHF",
    "QAR",
    "PHP",
    "THB",
    "AED",
    "CLP",
    "CZK",
    "HUF",
    "ISK",
    "INR",
    "IDR",
    "BHD",
    "KWD",
    "RSD",
    "OMR",
    "HKD",
    "CAD",
    "JPY",
    "BGN",
    "MXN",
    "COP",
    "NZD",
    "KZT",
    "PEN",
    "BRL",
    "MYR",
    "SAR",
    "KRW",
    "SGD"
];
export const isValidCurrency = (currency) => {
    const currencyUpper = currency.toUpperCase();
    return SUPPORTED_CURRENCIES.includes(currencyUpper);
};
